import Styles from './styles.module.css';
import SectionTitle from '../../home/_ui/sectionTitle';
import Placeholder from '../../home/_placeholder/index';

const FILTERS = ['勤務地', '給与', '休日', 'サロンの特徴', '写真', 'スタッフ情報', '求人条件'];

const Students = () => {
  return (
    <section className={Styles.students}>
      <SectionTitle
        pattern="A"
        kicker="For Students"
        title="管理が楽になるだけではなく、学生も探しやすくなる"
        lead="学校職員の業務が減るだけで終わりません。学生はスマートフォンから、自分に合う求人を自分で探せます。"
      />

      <div className={Styles.body}>
        <div className={Styles.text}>
          <p className={Styles.punch}>
            先生が求人票を探して渡すのではなく、<br />
            <strong>学生自身が探せる環境へ。</strong>
          </p>
          <ul className={Styles.filters}>
            {FILTERS.map((f) => <li key={f}>{f}</li>)}
          </ul>
        </div>

        <div className={Styles.shot}>
          <span className={Styles.shotTag}>学生アプリ 求人一覧 / 検索画面</span>
          {/* TODO: 学生アプリ（iOS）または学生Web( / )の求人検索・一覧・詳細の実スクリーンショットに差し替え */}
          <Placeholder label="学生アプリの求人検索・一覧画面" height={360} />
        </div>
      </div>
    </section>
  );
};

export default Students;
